// Owner: P1 piece 7 "Library" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): the library at /library, one lazy chunk. The selected item
// is the URL's `item` search value, a library id and nothing else (never free text).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { BookOpen } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './queries.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/library',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./LibraryScreen.tsx')),
    }),
  ],
  nav: [{ to: '/library', label: 'nav.library', icon: BookOpen, group: 'network', key: 'b' }],
}
